import { gql } from "@apollo/client";

export const getAccountSurveyQuery = gql`
query GetAccountSurveys($_eq: bigint = "") {
  account_surveys(where: {account_id: {_eq: $_eq}}) {
    account_id
    account{
    username
    details
    }
    survey_id
    survey {
      link
      name
    }
  }
}
`